import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './components/users/login.component';
import {AuthGuard} from './guards/auth.guard';
import {RoleGuard} from './guards/role.guard';
import { MainComponent } from './components/template/main.component';


const routes: Routes = [
  {path: '' , component: MainComponent, canActivate: [AuthGuard]},
  {path: 'login' , component: LoginComponent},
  {
    path: 'report',
    loadChildren: () => import('./components/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {authority: 'ROLE_REPORT'}
  },
  {
    path: 'order-entry',
    loadChildren: () => import('./components/order-entry/order-entry/order-entry.module').then(m => m.OrderEntryModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {authority: 'ROLE_ORDER_ENTRY'},
  },
  {
    path: 'order-entry',
    loadChildren: () => import('./components/order-entry/search-orders/search-orders.module').then(m => m.SearchOrdersModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {authority: 'ROLE_PHLEBOTOMY'},
  },
  {
    path: 'order-entry',
    loadChildren: () => import('./components/order-entry/order-entry-edit/order-entry-edit.module').then(m => m.OrderEntryEditModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {authority: 'ROLE_ORDER_ENTRY'},
  },
  {
    path: 'configuration',
    loadChildren: () => import('./components/configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {authority: 'ROLE_CONFIGURATION'} //ACA VA CONFIGURATION
  },
  {
    path: 'order-entry',
    loadChildren: () => import('./components/order-entry/remittances/remittances-routing.module').then(m => m.RemittancesRoutingModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {authority: 'ROLE_ORDER_ENTRY'},
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, onSameUrlNavigation: 'reload'}, )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
